
import React from 'react';
import PropTypes from 'prop-types';
import AlignCenter from '../../../../element/icons/align-center';
import AlignLeft from '../../../../element/icons/align-left';
import { AlignRight } from '../../../../utils/editorReactIcons';

import {
  StyledIconWrapper,
  StyledOptionIconRow,
  StyledSpacedOptionFields,
} from '../../../../components/common/AnnotationOptions/AnnotationOptions.styled';

const TextAlignmentFields = ({
  annotation: text,
  updateAnnotation: updateText,
  t,
}) => {
  const { align } = text;

  const changeHorizontalAlignment = (newHorizonalAlignment) => {
    updateText({ align: newHorizonalAlignment });
  };

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel respark_annotation-option-panel--compact">
      <StyledOptionIconRow>
        <StyledIconWrapper
          onClick={() => changeHorizontalAlignment('left')}
          aria-selected={align === 'left'}
          title={t ? t('alignLeft') : undefined}
        >
          <AlignLeft size={18} />
        </StyledIconWrapper>
        <StyledIconWrapper
          onClick={() => changeHorizontalAlignment('center')}
          aria-selected={align === 'center'}
          title={t ? t('alignCenter') : undefined}
        >
          <AlignCenter size={18} />
        </StyledIconWrapper>
        <StyledIconWrapper
          onClick={() => changeHorizontalAlignment('right')}
          aria-selected={align === 'right'}
          title={t ? t('alignRight') : undefined}
        >
          <AlignRight size={18} />
        </StyledIconWrapper>
      </StyledOptionIconRow>
    </StyledSpacedOptionFields>
  );
};

TextAlignmentFields.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func,
};

export default TextAlignmentFields;
